import { render, staticRenderFns } from "./inspectInventory.vue?vue&type=template&id=3b68fa5c&scoped=true"
import script from "./inspectInventory.vue?vue&type=script&lang=ts"
export * from "./inspectInventory.vue?vue&type=script&lang=ts"
import style0 from "./inspectInventory.vue?vue&type=style&index=0&id=3b68fa5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68fa5c",
  null
  
)

export default component.exports